import { useEffect, useRef, useState } from "react";
import { SimpleIconButton } from "../../../misc/lists/SimpleIconButton";
import { Popover } from "../../../misc/Popover";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function IconPopupItem(props) {
    const [anchorEl, setAnchorEl] = useState();
    const lastFocus = useRef(0);
    const popFocused = useRef(false);
    const controlled = props.open !== undefined;
    useEffect(() => { if (!anchorEl)
        return; if (controlled)
        return; const int = setInterval(() => { if (!anchorEl)
        return; if (popFocused.current)
        return; if (Date.now() - lastFocus.current > 200) {
        setAnchorEl(null);
    } }, 100); return () => clearInterval(int); }, [anchorEl, controlled]);
    const open = props.open !== undefined ? props.open : !!anchorEl;
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx(SimpleIconButton, { onMouseEnter: e => { setAnchorEl(e.target); if (props.onOpen)
                    props.onOpen(true); }, children: props.icon }), anchorEl && open && /*#__PURE__*/ _jsx(Popover, { anchorOrigin: { /* overlap to make mouse event easier */ vertical: 'top', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, anchorEl: anchorEl, open: true, onClose: () => { if (props.onOpen) {
                    props.onOpen(false);
                }
                else {
                    setAnchorEl(null);
                } }, ref: r => {
                    if (!r)
                        return;
                    setTimeout(() => {
                        const ev = new Event("resize");
                        window.dispatchEvent(ev);
                    }, 500);
                }, children: /*#__PURE__*/ _jsx("div", { onMouseOver: () => { popFocused.current = true; }, onMouseOut: () => { popFocused.current = false; lastFocus.current = Date.now(); }, style: { paddingTop: 8, paddingBottom: 8, maxHeight: window.innerHeight * 0.8, overflowY: "auto" }, children: props.children }) })] });
}
